<template>
  <!-- 基本信息表单 -->
  <div class="form-box" style="background-color:#fff">
    <template>
      <el-form
        ref="form"
        :model="submit_data"
        label-width="80px"
        style="overflow-y: auto"
      >
        <div style="display: flex; border-bottom: 1px solid #e4e4e4">
          <div style="font-size: 20px; font-weight: 700; color: #606266">
            合伙人设置
          </div>

          <div>
            <el-form-item label="合伙人设置:" label-width="120px">
              <el-switch
                v-model="submit_data.distribution_status"
                active-value="1"
                inactive-value="0"
              ></el-switch>
              <el-tooltip
                class="item"
                effect="dark"
                content="开启后对应城市客户端显示入口"
                placement="right"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </div>
        </div>

        <el-form-item label="合伙人审核:" label-width="120px">
          <el-switch
            v-model="submit_data.review_status"
            active-value="1"
            inactive-value="0"
          ></el-switch>
          <el-tooltip
            class="item"
            effect="dark"
            content="选择开启，用户需要申请才能成为合伙人，选择关闭，申请自动通过"
            placement="right"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="合伙提成方式:" label-width="120px">
          <el-radio-group
            v-model="submit_data.commission_type"
            @change="commissionChange"
          >
            <el-radio label="1">百分比金额</el-radio>
            <el-radio label="2">固定金额</el-radio
            ><el-tooltip
              class="item"
              effect="dark"
              content="固定金额：按设置的固定金额提成；百分比：按订单金额百分比提成"
              placement="right"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-radio-group>
        </el-form-item>
        <div v-if="submit_data.commission_type == '1'">
          <el-form-item label="一级合伙人:" label-width="120px">
            <el-input
              v-model="submit_data.first_level_commission"
              placeholder="一级合伙人百分比"
              style="width: 150px; margin-right: 5px"
            ><template slot="append">%</template>
            </el-input
            >
            <el-tooltip
              class="item"
              effect="dark"
              content="邀请用户返佣按1级合伙人比例返佣"
              placement="right"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>

          <el-form-item label="二级合伙人:" label-width="120px">
            <el-input
              v-model="submit_data.second_level_commission"
              placeholder="二级合伙人百分比"
              style="width: 150px; margin-right: 5px"
            ><template slot="append">%</template>
            </el-input
            >
            <el-tooltip
              class="item"
              effect="dark"
              content="邀请用户返佣按2级合伙人比例返佣"
              placement="right"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>
        </div>
        <div v-if="submit_data.commission_type == '2'">
          <el-form-item label="一级合伙人:" label-width="120px">
            <el-input
              v-model="submit_data.first_level_commission"
              placeholder="一级合伙人金额"
              style="width: 150px; margin-right: 5px"
            >
            </el-input
            >元
            <el-tooltip
              class="item"
              effect="dark"
              content="邀请用户返佣按1级合伙人比例返佣"
              placement="right"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>

          <el-form-item label="二级合伙人:" label-width="120px">
            <el-input
              v-model="submit_data.second_level_commission"
              placeholder="二级合伙人金额"
              style="width: 150px; margin-right: 5px"
            >
            </el-input
            >元
            <el-tooltip
              class="item"
              effect="dark"
              content="邀请用户返佣按2级合伙人比例返佣"
              placement="right"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>
        </div>

        <el-form-item label="邀请合伙人推广海报背景图:" label-width="120px">
          <el-tooltip
            class="item"
            effect="dark"
            content="图片建议尺寸：710*1138"
            placement="right"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>

          <el-image
            :preview-src-list="srcList"
            v-if="img_url.invite_promoter_image_url"
            :src="img_url.invite_promoter_image_url"
            class="avatar"
          ></el-image>
          <el-upload
            :class="img_url.invite_promoter_image_url ? 'border-none' : ''"
            class="avatar-uploader"
            :action="img_upload_url"
            :show-file-list="false"
            :before-upload="promoterImageSuccess"
            :headers="img_headers"
          >
            <el-button
              slot="trigger"
              v-if="img_url.invite_promoter_image_url"
              @click="img_url.invite_promoter_image_url = ''"
              style="width: 100px; margin-top: 10px"
              >更换图片</el-button
            >
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="邀请用户推广海报背景图:" label-width="120px">
          <el-tooltip
            class="item"
            effect="dark"
            content="图片建议尺寸：710*1138"
            placement="right"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
          <el-image
            :preview-src-list="srcList"
            v-if="img_url.invite_user_image_url"
            :src="img_url.invite_user_image_url"
            class="avatar"
          ></el-image>
          <el-upload
            :class="img_url.invite_user_image_url ? 'border-none' : ''"
            class="avatar-uploader"
            :action="img_upload_url"
            :show-file-list="false"
            :before-upload="userImageSuccess"
            :headers="img_headers"
          >
            <el-button
              slot="trigger"
              v-if="img_url.invite_user_image_url"
              @click="img_url.invite_user_image_url = ''"
              style="width: 100px; margin-top: 10px"
              >更换图片</el-button
            >
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <div
          style="
            font-size: 20px;
            font-weight: 700;
            color: #606266;
            border-bottom: 1px solid #e4e4e4;
            padding-bottom: 10px;
          "
        >
          其他设置
        </div>

        <el-form-item label="锁客时效:" label-width="120px">
          <el-radio-group
            v-model="submit_data.invite_user_timelimit"
            @change="inviteChange"
          >
            <el-radio label="1">永久性</el-radio>
            <el-radio label="2">限制时效天数</el-radio>
          </el-radio-group>
          <el-tooltip
            class="item"
            effect="dark"
            content="用户扫合伙码后，在规定时效内，进入系统授权可绑定合伙关系"
            placement="right"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>

        <el-form-item
          label="限制时效天数:"
          label-width="120px"
          v-if="submit_data.invite_user_timelimit == '2'"
        >
          <el-input
            v-model="submit_data.user_timelimit_days"
            placeholder="限制时效天数"
            style="width: 150px; margin-right: 5px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="推广优惠:" label-width="120px">
          <el-select
            v-model="submit_data.package_code"
            placeholder="请选择优惠券礼包"
            clearable
          >
            <el-option
              :label="item.name"
              :value="item.code"
              v-for="(item, index) in packageArray"
              :key="index"
            >
            </el-option>
          </el-select>
          <el-tooltip
            class="item"
            effect="dark"
            content="需在城市管理端提前配置优惠券礼包（活动-渠道优惠券礼包）"
            placement="right"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>

      <!-- 对话框底部按钮 -->
      <div style="display: flex; justify-content: center">
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </div>
    </template>
  </div>
</template>

<script>
var _this;
import bus from "@/components/common/bus.js";
export default {
  data() {
    return {
      packageArray: [],

      // 图片上传地址
      img_upload_url: "",
      // 上传图片的请求头
      img_headers: {
        "city-tag": "",
        token: "",
        "hash-key": "",
        platform: "pc",
        "app-version": "admin",
        port: "admin",
      },
      srcList: [],
      img_url: {
        invite_user_image_url: "",
        invite_promoter_image_url: "",
      },

      show: false,

      // 表单数据
      submit_data: {
        distribution_status: "0",
        review_status: "0",
        commission_type: "1",
        first_level_commission: "",
        second_level_commission: "",
        invite_promoter_image: "",
        invite_user_image: "",
        invite_user_timelimit: "1",
        user_timelimit_days: "",
        package_code: "",

      },
      search_data: {

      },
      search_data_package: {
        page: 1,
        limit: 10,

      },

      submit_rules: {
        distribution_status: {
          placeholder: "合伙人设置",
          rules: {
            required: true,
            message: "请选择合伙人设置",
            regulation: "gt_str",
            rulesData: "0",
          },
        },
        review_status: {
          placeholder: "合伙人审核",
          rules: {
            required: true,
            message: "合伙人审核错误",
            regulation: "gt_str",
            rulesData: "0",
          },
        },
        commission_type: {
          placeholder: "合伙提成方式",
          rules: {
            required: true,
            message: "合伙提成方式错误",
            regulation: "gt_str",
            rulesData: "0",
          },
        },
        first_level_commission: {
          placeholder: "一级合伙人",
          rules: {
            required: true,
            message: "一级合伙人错误",
            regulation: "number",
            rulesData: "0",
          },
        },
        second_level_commission: {
          placeholder: "二级合伙人",
          rules: {
            required: true,
            message: "二级合伙人",
            regulation: "number",
            rulesData: 0,
          },
        },

        invite_promoter_image: {
          placeholder: "邀请用户推广海报背景图",
          rules: {
            required: true,
            message: "邀请用户推广海报背景图",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        invite_user_image: {
          placeholder: "邀请合伙人推广海报背景图",
          rules: {
            required: true,
            message: "邀请合伙人推广海报背景图",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        invite_user_timelimit: {
          placeholder: "锁客时效",
          rules: {
            required: true,
            message: "锁客时效",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        user_timelimit_days: {
          placeholder: "用户时效天数",
          rules: {
            required: false,
            message: "用户时效天数",
            regulation: "number",
            rulesData: 0,
          },
        },
        package_code: {
          placeholder: "推广优惠",
          rules: {
            required: false,
            message: "推广优惠",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
      },
    };
  },
  created() {
    _this = this;

    _this.clearCity();
  },

  methods: {
    clearCity() {
  
      _this.submit_data = {
        distribution_status: "0",
        review_status: "0",
        commission_type: "1",
        first_level_commission: "",
        second_level_commission: "",
        invite_promoter_image: "",
        invite_user_image: "",
        invite_user_timelimit: "1",
        user_timelimit_days: "",
        package_code: "",
  
      };

   
      _this.packageArray = [];
      _this.srcList = [];
      _this.img_url = {
        invite_user_image_url: "",
        invite_promoter_image_url: "",
      };

      _this.getSelectCouponPackage();
      _this.getDistributionConfig();
    },
    // 获取推广优惠
    getSelectCouponPackage() {
      _this
        .$post("/package/getSelectCouponPackage", _this.search_data_package)
        .then((res) => {
          _this.packageArray = res.data;

      
        })
        .catch((err) => {});
    },

    // 锁客时效change方法
    inviteChange() {
 
      _this.submit_data.user_timelimit_days = "";
    },

    // 合伙提成方式change
    commissionChange() {
      _this.submit_data.first_level_commission = "";
      this.submit_data.second_level_commission = "";
    },


    // 详情
    getDistributionConfig() {
      _this
        .$post("/distribution/getDistributionConfig", _this.search_data)
        .then((res) => {
          _this.submit_data.distribution_status =
            res.data.distribution_status || "0";
          // 设置过和没设置过，接口返回数据格式不一样，所以前端加判断，如果接口有返回值就赋值，没有返回值就赋值为空
          if (res.data.review_status) {
            _this.submit_data.review_status = res.data.review_status;
          }
          if (res.data.package_code) {
            _this.submit_data.package_code = res.data.package_code;
          }

          if (res.data.commission_type) {
            _this.submit_data.commission_type = res.data.commission_type;
          }

          if (res.data.first_level_commission) {
            _this.submit_data.first_level_commission =
              res.data.first_level_commission;
          }

          if (res.data.second_level_commission) {
            _this.submit_data.second_level_commission =
              res.data.second_level_commission;
          }

          if (res.data.user_timelimit_days) {
            _this.submit_data.user_timelimit_days =
              res.data.user_timelimit_days;
          }
          if (res.data.invite_user_timelimit) {
            _this.submit_data.invite_user_timelimit =
              res.data.invite_user_timelimit;
          }

          _this.srcList.length = 0;
  

          if (res.data.invite_promoter_image_url != "") {
            _this.srcList.push(res.data.invite_promoter_image_url);
            _this.img_url.invite_promoter_image_url =
              res.data.invite_promoter_image_url;
            _this.submit_data.invite_promoter_image =
              res.data.invite_promoter_image;
          }
          if (res.data.invite_user_image_url != "") {
            _this.srcList.push(res.data.invite_user_image_url);
            _this.img_url.invite_user_image_url =
              res.data.invite_user_image_url;
            _this.submit_data.invite_user_image = res.data.invite_user_image;
          }

        
        })
        .catch((err) => {});
    },
    // 照片上传成功后执行 两个参数，file代表上传的文件，isSave代表上传的policyName参数是临时文件还是永久文件。permanent（永久文件）temporary（临时文件）
    promoterImageSuccess(file) {
      _this.$uploadImage({ file: file, isSave: "permanent" }).then((res) => {
        // console.log(file, '1============');

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.invite_promoter_image = res.hash;
        // console.log(res.hash, "=================");

        // 设置img标签显示的图片路径
        _this.img_url.invite_promoter_image_url = URL.createObjectURL(file);
  

        //上传图片后点击预览
        _this.srcList.push(String(_this.img_url.invite_promoter_image_url));
   
      });

      return false;
    },


    // 上传照片
    userImageSuccess(file) {
      _this.$uploadImage({ file: file, isSave: "permanent" }).then((res) => {
        // console.log(file, '1============');

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.invite_user_image = res.hash;

        // 设置img标签显示的图片路径
        _this.img_url.invite_user_image_url = URL.createObjectURL(file);

        //上传图片后点击预览
        _this.srcList.push(String(_this.img_url.invite_user_image_url));
      });

      return false;
    },
    // 提交
    onSubmit() {
      if (_this.submit_data.package_code == null) {
        _this.submit_data.package_code = "";
      }

      if (_this.submit_data.invite_user_timelimit == "2") {
        // 如果锁客时效为 限制时效天数，则 限制时效天数为必填项
        _this.submit_rules.user_timelimit_days.rules.required = true;
     
      } else {

        _this.submit_rules.user_timelimit_days.rules.required = false;
        _this.submit_data.user_timelimit_days = "";
     
      }


      // 提交接口
      _this
        .$post(
          "/distribution/saveDistributionConfig",
          _this.submit_data,
          _this.submit_rules
        )
        .then((res) => {
          _this.$message.success("success");
          _this.getDistributionConfig(); // 提交数据后重新获取详情
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped>
.form-box {
  padding: 20px;
  box-sizing: border-box;
  margin-right: 0;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-form-second {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
}

.avatar-uploader img {
  display: block;
  width: 100%;
  height: 100%;
}

.verify_remarks {
  font-size: 14px;
  color: #606266;
}

.quill-editor {
  width: 80%;
}
</style>